import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject } from 'rxjs';
import { ReportingControlsComponent } from '@flyfreely/user-reporting-dashboard';
import { DashboardService } from '@flyfreely-portal-ui/flyfreely';

@Component({
    selector: 'flyfreely-portal-ui-report-side-bar',
    templateUrl: './report-side-bar.component.html',
    styleUrls: ['./report-side-bar.component.scss'],
    standalone: true,
    imports: [CommonModule, ReportingControlsComponent]
})
export class ReportSideBarComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    constructor(
        public dashboardService: DashboardService
    ) {}

    ngOnInit(): void {
        // Component initialization
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}

